export const getStoreLocal = (name: string) => {
  let retVal = null;
  if (typeof localStorage !== undefined) {
    const ls = localStorage.getItem(name);

    if(ls && ls !== 'undefined'){
      try {
        retVal = JSON.parse(ls);
      } catch (error) {
        console.log(error);
      }
    }
  }

  return retVal;
};

export const setStoreLocal = <T>(name: string, data: T) => {
  localStorage.setItem(name, JSON.stringify(data));
};
